import React from 'react'
import { useLocation, Link } from 'react-router-dom'

import _routes from '../_routes'

import { CBreadcrumb } from '@coreui/react'
import { useAppSelector } from '../redux/hooks'
import { selectCurrentUser } from '../redux/features/currentUser/currentUserSlice'
import { _dictionary } from '../utils/translate'

const AppBreadcrumb = () => {
  const currentUser = useAppSelector(selectCurrentUser)
  const translate = _dictionary(currentUser?.active_language || null)
  const currentLocation = useLocation().pathname

  const getRouteName = (pathname, routes) => {
    const currentRoute = routes.find((route) => route.path === pathname)
    return currentRoute?.name || null // currentRoute could be undefined when it is wildcard path
  }

  const getBreadcrumbs = (location) => {
    const breadcrumbs = []
    location.split('/').reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`
      const routeName = getRouteName(currentPathname, _routes)

      breadcrumbs.push({
        pathname: currentPathname,
        name: translate(routeName || 'Detail Page'),
        active: index + 1 === array.length ? true : false,
      })
      return currentPathname
    })
    return breadcrumbs
  }

  const breadcrumbs = getBreadcrumbs(currentLocation)

  return (
    <CBreadcrumb className="m-0 ms-2">
      <li className={`breadcrumb-item`}>
        <Link to={'/'}>{translate('Home')}</Link>
      </li>
      {breadcrumbs.map((breadcrumb, index) => {
        return (
          <li
            className={`breadcrumb-item ${breadcrumb.active ? 'active' : ''}`}
            {...(breadcrumb.active && { 'aria-current': 'page' })}
            key={index}
          >
            {breadcrumb.active ? (
              translate(breadcrumb.name)
            ) : (
              <Link to={breadcrumb.pathname}>{translate(breadcrumb.name)}</Link>
            )}
          </li>
        )
      })}
    </CBreadcrumb>
  )
}

export default React.memo(AppBreadcrumb)
